import { render, staticRenderFns } from "./pre-activity-alert-modal.vue?vue&type=template&id=64cb1988&scoped=true"
import script from "./pre-activity-alert-modal.vue?vue&type=script&lang=js"
export * from "./pre-activity-alert-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb1988",
  null
  
)

export default component.exports